import {Link} from "@/helpers/navigation";
import {Fragment} from "react";

const flattenItems = (items) => items.flatMap((item) => [item, ...(item.children ? flattenItems(item.children) : [])])

export const getSidebarItems = (pathname, items, settings) => {
    items = items.map((item) => getSidebarLink(pathname, item, settings))

    const selected = flattenItems(items)
        .filter(item => item.selected)
        .map(item => item.key)

    return [items, selected]
}

export const getSidebarLink = (pathname, item, settings) => {
    const {key, href, label, children} = item
    const getSelectedClosure = getSelected(pathname)
    const Component = settings?.wrapper ? settings?.wrapper : href ? Link : ({children}) => <>{children}</>

    const link = {
        ...item,
        key,
        label: <Component href={href || key} key={key}>{label}</Component>,
        selected: getSelectedClosure(item),
    }

    if (!!children?.length) {
        const [items, selected] = getSidebarItems(pathname, children, settings)

        if(selected.length > 0) {
            link.href = ''
            link.label = <Component href={link.href} key={key}>{label}</Component>
        }

        link.selected = !!selected.length
        link.children = items;
    }

    return link
}

export const getSelected = (pathname) => {
    return item => item.key.startsWith('/') ? pathname.endsWith(item.key) : pathname.includes(item.key)
}
